<template>
    <div class="flex items-center gap-6">
        <div class="my-2 h-[125px] w-[100px] shrink-0 animate-pulse rounded bg-green-200"></div>
        <div class="flex w-full flex-col gap-2">
            <div class="mt-[10px] h-4 w-32 animate-pulse rounded bg-green-200"></div>
            <div class="h-3 w-48 animate-pulse rounded bg-green-200"></div>
            <div class="h-4 w-16 animate-pulse rounded bg-green-200"></div>
        </div>

        <div class="flex w-max flex-col items-end justify-between pl-2">
            <div class="size-[22px] animate-pulse rounded bg-green-200"></div>
        </div>
    </div>
</template>
